import React, { memo, useEffect, useState } from "react"
import {
  LocationMolecule,
  RadioButtonGroup,
  SelectInput,
  TextInput
} from "../../../../component/index.jsx"
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useFormikContext } from "formik"
import { LABELING_CONST, UNIT_STRING } from "../../../../constants/StringConstant.js"

const FilterComponent = ({
  isReadOnly,
  onChangeMitra,
  onChangeBa,
  onChangeMin,
  onChangeMax,
  onChangeLabelType,
  mitra,
  hasBa,
  min,
  max,
  labelType,
  reset,
  onValuesChange
}) => {
  const { t } = useTranslation()

  const [stateMitra, setStateMitra] = useState()

  const { Mitralist } = useSelector((state) => state)
  const { values } = useFormikContext()

  useEffect(() => {
    if (onValuesChange) onValuesChange(values)
  }, [values, onValuesChange])

  useEffect(() => {
    if (Mitralist.data) {
      setStateMitra(
        Mitralist.data.map((value) => ({
          label: value.name,
          value: value.id_mitra
        }))
      )
    }
  }, [Mitralist.data])

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_mitra")} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <SelectInput
              name="mitra_id"
              onChange={onChangeMitra}
              editable={!isReadOnly}
              label={t("label_mitra_name")}
              placeholder={t("placeholder_choose_one")}
              options={stateMitra}
              withoutFeedback={true}
              clearNow={true}
              value={mitra}
            />
          </RowModule>
        </CardBody>
      </Card>

      <LocationMolecule
        resetLocation={reset}
        name="filter"
        withoutFeedback={true}
        isReadOnly={isReadOnly}
        addressTitle={t("label_location")}
        removeHorizontalPadding={true}
      />

      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_land_area_m2")} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_min")}
              name="min_area"
              placeholder={t("placeholder_min_value")}
              withoutFeedback={true}
              value={min}
              onChangeValue={onChangeMin}
              unit={UNIT_STRING.M2}
            />
          </RowModule>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_max")}
              name="max_area"
              placeholder={t("placeholder_max_value")}
              withoutFeedback={true}
              value={max}
              onChangeValue={onChangeMax}
              unit={UNIT_STRING.M2}
            />
          </RowModule>
        </CardBody>
      </Card>

      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_ba")} className="px-0" />
        <CardBody className="px-0">
          <RadioButtonGroup
            editable={true}
            label={t("label_has_ba")}
            value={"true"}
            onClick={() => onChangeBa("true")}
            checked={hasBa === "true"}
            name="has_ba"
          />
          <RadioButtonGroup
            editable={true}
            label={t("label_no_ba")}
            value={"false"}
            onClick={() => onChangeBa("false")}
            checked={hasBa === "false"}
            name="has_ba"
          />
        </CardBody>
      </Card>

      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_kemitraan_status")} className="px-0" />
        <CardBody className="px-0">
          <RadioButtonGroup
            editable={true}
            label={t("label_freeze")}
            value={LABELING_CONST.FROZEN}
            onClick={() => onChangeLabelType(LABELING_CONST.FROZEN)}
            checked={labelType === LABELING_CONST.FROZEN}
            name="label_type"
          />
          <RadioButtonGroup
            editable={true}
            label={t("label_blacklist")}
            value={LABELING_CONST.BLACKLISTED}
            onClick={() => onChangeLabelType(LABELING_CONST.BLACKLISTED)}
            checked={labelType === LABELING_CONST.BLACKLISTED}
            name="label_type"
          />
        </CardBody>
      </Card>
    </>
  )
}

export default memo(FilterComponent)
